

export default {
    name: 'setting',
    path: 'setting',
    meta: {
        title: '系统管理'
    },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'setting-operation',
            path: 'operation',
            meta: { title: '系统配置' },
            component: ()=>import('@/pages/operation/operation.vue')
        },
        {
            name: 'setting-licenseagree',
            path: 'licenseagree',
            meta: { title: '授权协议' },
            component: ()=>import('@/pages/operation/licenseagree.vue')
        }
    ]
} 
   


